import { Scene } from "three";

const scenes = {
  main: new Scene(),
  background: new Scene(),
};

export default scenes;
